import { render, staticRenderFns } from "./TransferTeamToNextRound.vue?vue&type=template&id=5e9ce4ea&scoped=true"
import script from "./TransferTeamToNextRound.vue?vue&type=script&lang=js"
export * from "./TransferTeamToNextRound.vue?vue&type=script&lang=js"
import style0 from "./TransferTeamToNextRound.vue?vue&type=style&index=0&id=5e9ce4ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9ce4ea",
  null
  
)

export default component.exports